// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC. 

import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

export interface AchParameter extends ApiParameter {
    accountNumber?: string;
    routingNumber?: string;
    bankName?: string;
    accountType?: string;
    approvedForACHProcessing?: boolean;
    bankAcctName?: string;
    accountNumberLabel?: string;
    bankGuid?: string;
}

export interface GetBankParameter extends ApiParameter {
    routingNumber: string;
}

const AchUrl = "api/rugby/ach";
const AchBankNameUrl = "api/rugby/ach/getbankname";

export async function getAch(parameter: AchParameter) {
    const ACHData = await get<AchParameter>(AchUrl, parameter);
    return ACHData;
}

export async function addAch(parameter: AchParameter) {
    const AddACHData = await post<any>(AchUrl, parameter);
    return AddACHData;
}

export async function getAchBankNameAPI(parameter: GetBankParameter) {
    const bankName = await get<string>(AchBankNameUrl, parameter);
    return bankName;
}
